document.addEventListener("DOMContentLoaded", function () {
  if (document.location.hash === "#form") {
    $(".parties-info").hide();
    $(".parties-form").show();
  } else {
    $(".parties-info").show();
  }

  $(".btn-start").on("click", function () {
    $(".parties-info").hide();
    $(".parties-form").show();
    $(".btn-start").hide();
  });

  // form
  $("form.form-parties").on("submit", function (e) {
    var $alert = $(".alert");
    var $alertMessage = $(".alert-message");
    var values = $(this).serializeArray();
    var data = {};
    values.forEach(function (o) {
      if (data[o.name]) {
        data[o.name] += ";" + String(o.value || "").trim();
      } else {
        data[o.name] = String(o.value || "").trim();
      }
    });

    // reset validation
    $alert.addClass("d-none");
    $(".is-invalid").removeClass("is-invalid");

    var validate = ["Name", "Email", "Confirm", "Phone", "Location", "GuestOfHonour", "Guests", "Time", "Dates"];
    var errors = 0;

    validate.forEach(function (name) {
      if (data[name] !== undefined && data[name].length === 0) {
        $('input[name="' + name + '"],textarea[name="' + name + '"],select[name="' + name + '"]').addClass("is-invalid");
        errors += 1;
      }
    });

    if (errors > 0) {
      $alert.removeClass("d-none");
      $alertMessage.text("Please fill out the entire form.");
      return false;
    }

    executeRecaptcha("parties").then(function (token) {
      data["g-recaptcha-token"] = token;
      $.ajax({
        type: "post",
        url: "/api/contact/junior_parties",
        data: data,
        cache: false,
        dataType: "json",
        success: function (response) {
          if (response.success === 0) {
            $alert.removeClass("d-none");
            $alertMessage.text(response.message);
            return;
          }

          $(".parties-form").hide();
          $(".parties-thankyou").show();

          if (ENABLE_ANALYTICS) {
            gtag("event", "sent", { send_to: "G-HCCXE3E0V3", event_category: "parties" });
          }
        },
        error: function (xhr, status) {
          $alert.removeClass("d-none");
          $alertMessage.text("There was a connection error. Please try again.");
        },
      });
    }).catch(function () {
      $alert.removeClass("d-none");
      $alertMessage.text("There was a connection error. Please try again.");
    });

    return false;
  });
});
